
<!-- <div>
  <div id="bullet-chart-section-savinghrs" class="bullet-chart-section-savinghrs"> </div>
</div> -->

<div>
  <div id="{{chartIdSelector}}" class="mri-bulletsavinghrs-chart-cmpSec"> </div>
</div>